import {Component, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {Chat, ChatMessage} from "../../messages/chat.model";
import {MessagesService} from "../../messages/messages.service";
import {AuthService} from "../../login/auth.service";
import { Message } from 'primeng/message';
import { ToastMessageOptions } from 'primeng/api';


@Component({
    selector: 'app-simple-messages',
  imports: [
    Message
  ],
    templateUrl: './simple-messages.component.html',
    styleUrl: './simple-messages.component.scss',
  standalone: true
})
export class SimpleMessagesComponent implements OnInit {
  messages: WritableSignal<ToastMessageOptions[]> = signal([]);
  loadingMessages: WritableSignal<boolean> = signal(false);

  messagesService: MessagesService = inject(MessagesService);
  authService: AuthService = inject(AuthService);

  ngOnInit() {
    void this.loadMessages()
  }

  async loadMessages() {
    this.loadingMessages.set(true);
    if (this.authService.user() === null) {
      await this.authService.fetchMe()
    }
    const chats = await this.messagesService.fetchMyChats();
    this.messages.set(chats
      .filter((chat) => this.unreadCount(chat) > 0)
      .map((chat) => ({
      severity: 'info',
      detail: `${this.chatTitle(chat)}: ${this.lastUnreadMessage(chat)?.body ?? 'Neue Nachricht'}`,
      closable: true,
      id: chat.id
    })));
    this.loadingMessages.set(false);
  }

  async markAsSeen(msg: ToastMessageOptions) {
    await this.messagesService.markChatAsRead(Number(msg.id));
    void this.loadMessages();
  }

  private unreadCount(chat: Chat): number {
    const currentUserId = this.authService.user()?.id;
    const ownMember = chat.chat_members?.find((member) => member.user?.id === currentUserId);
    const lastReadAt = ownMember?.last_read_at ? new Date(ownMember.last_read_at).getTime() : 0;
    return (chat.chat_messages ?? []).filter((message) =>
      message.users_permissions_user?.id !== currentUserId &&
      new Date(message.sent_at ?? message.createdAt ?? 0).getTime() > lastReadAt
    ).length;
  }

  private lastUnreadMessage(chat: Chat): ChatMessage | undefined {
    const currentUserId = this.authService.user()?.id;
    return [...(chat.chat_messages ?? [])]
      .reverse()
      .find((message) => message.users_permissions_user?.id !== currentUserId);
  }

  private chatTitle(chat: Chat): string {
    const currentUserId = this.authService.user()?.id;
    const otherMembers = chat.chat_members?.filter((member) => member.user?.id !== currentUserId) ?? [];
    if (chat.name) return chat.name;
    return otherMembers
      .map((member) => `${member.user?.first_name ?? ''} ${member.user?.last_name ?? ''}`.trim() || member.user?.username)
      .filter(Boolean)
      .join(', ') || 'Nachricht';
  }
}
